// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"SingleDateCalendar_calendarContainer__1shyb"};